import { useFetch, useFetchCb } from '@gluedigital/ruse-fetch-extras'
import { AUTH_URL } from 'src/constants/global'
import type { Association, ConectorInfo } from 'src/types/auth'

interface ConnectorDataResponse {
  ok: boolean
  connector: ConectorInfo
}

interface AssocResponse {
  ok: boolean
  association: Association
}

interface ConectorInfoResponse {
  ok: boolean
  connectors: ConectorInfo[]
}

export const useConnectors = () => {
  const { connectors } = useFetch<ConectorInfoResponse>(
    AUTH_URL + '/connectors'
  )
  return connectors
}

export const useConnectorData = (id: string): ConectorInfo => {
  const { connector } = useFetch<ConnectorDataResponse>(
    AUTH_URL + '/connector/' + id
  )
  return connector
}

export const useAssocInfo = (id: string): Association => {
  const { association } = useFetch<AssocResponse>(
    AUTH_URL + '/connector/review/' + id
  )
  return association
}

export const useConnectorCRUD = () => {
  const doConfirm = useFetchCb()
  const doDelete = useFetchCb()
  const refreshData = useFetchCb()

  const confirmConnector = async (id: string) => {
    return await doConfirm(AUTH_URL + '/connector/confirm/', {
      method: 'PUT',
      body: { uuid: id }
    })
  }
  const deleteConnector = async (id: string) => {
    return await doDelete(AUTH_URL + '/connector/remove/', {
      method: 'DELETE',
      body: { uuid: id }
    })
  }

  const refreshConnectors = async () => {
    return await refreshData(AUTH_URL + '/connectors')
  }

  return { confirmConnector, deleteConnector, refreshConnectors }
}
